import { MdOutlineMyLocation } from "react-icons/md";
import BaseButton from "./BaseButton";
import { trackUIButtonClick } from "@/utils/analytics";
import { useTranslation } from "react-i18next";

type LocationButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: React.ReactNode;
};

const LocationButton: React.FC<LocationButtonProps> = ({
  className = "",
  onClick,
  label,
  children,
  ...rest
}) => {
  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    trackUIButtonClick("location");
    onClick?.(event);
  };

  const content = children ?? label ?? t("現在地に戻る");

  return (
    <BaseButton
      icon={MdOutlineMyLocation}
      className={`min-h-[44px] min-w-[148px] px-3 ${className}`}
      textVariant="body/m"
      onClick={handleClick}
      {...rest}
    >
      {content}
    </BaseButton>
  );
};

export default LocationButton;
